import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import {userActions} from '../../_actions';
import DashboardBanner from '../../_components/DashboardBanner';
import DashboardButtonBack from '../../_components/DashboardButtonBack';
import {
  makeStyles,
  TextField,
  List,
  ListItem,
  ListItemText,
} from '@material-ui/core';
import Button from '@mui/material/Button';
import axInstTD from '../../_helpers/axios-td';

const useStyles = makeStyles(theme => ({
  container: {
    maxWidth: 1246,
    margin: '40px auto',
    padding: '0 15px',
  },
  body: {
    boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
    borderRadius: 8,
    backgroundColor: '#fff',
    margin: '0 auto',
    width: '90%',
    padding: '50px 30px',
    [theme.breakpoints.down(768)]: {
      padding: '30px 15px',
    },
  },
  back: {
    paddingBottom: '50px',
    [theme.breakpoints.down(768)]: {
      paddingBottom: '30px',
    },
  },
  novaPoshtaSelect: {
    marginTop: 20,
    position: 'relative',
    zIndex: 999998,
    maxWidth: 400,
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    fontSize: 14,
  },
  dropdown: {
    position: 'absolute',
    zIndex: 999999,
    width: '100%',
    maxHeight: 240,
    overflowY: 'auto',
    backgroundColor: '#fff',
    border: '1px solid #ccc',
    borderRadius: 6,
    top: 40,
    boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
    '&>div': {
      fontSize: 13,
    },
  },

  saveButton: {
    border: 'none !important',
    borderRadius: '20px !important',
    fontSize: '14px !important',
    fontWeight: '700 !important',
    color: '#1F1F1F !important',
    maxWidth: 'max-content !important',
    background: '#FFBE00 !important',
    fontSize: '13px !important',
    lineHeight: '22px !important',
    boxSizing: 'border-box !important',
    cursor: 'pointer !important',
    height: '38px !important',
    display: 'flex !important',
    justifyContent: 'center !important',
    alignItems: 'center !important',
    width: 'max-content !important',

    [theme.breakpoints.down('sm')]: {
      maxWidth: 'unset',
      width: 'max-content',
    },
  },
}));

const DashboardStorekeeperSettings = props => {
  const {
    frontendData,
    userSelectedData,
    userCityNpWarehouse,
    personalManager,
    getUserCityNpWarehouse,
    getPersonalManager,
    updateSenderCityNpWarehouse,
    senderCityNpWarehouse,
  } = props;

  const classes = useStyles();
  const [adress, setAdress] = useState(null);
  const [isDisabled, setIsDisabled] = useState(false);

  useEffect(() => {
    if (userSelectedData?.customer_id) {
      getPersonalManager(userSelectedData.customer_id);
    }
    if (frontendData?.user?.id && userSelectedData?.customer_id) {
      getUserCityNpWarehouse(
        userSelectedData.customer_id,
        frontendData.user.id,
      );
    }
  }, [userSelectedData, frontendData]);

  const [query, setQuery] = useState({city: '', warehouse: ''});
  const [queries, setQueries] = useState({city: [], warehouse: []});
  const [isSearching, setIsSearching] = useState({
    city: false,
    warehouse: false,
  });
  const [isEditingWarehouse, setIsEditingWarehouse] = useState(false);

  const [selectedQuery, setSelectedQuery] = useState({
    City: {
      Present: '',
      DeliveryCity: '',
      MainDescription: '',
      Ref: '',
    },
    Warehouse: {
      Ref: '',
      Description: '',
      WarehouseStatus: '',
    },
  });

  useEffect(() => {
    if (query.city.length > 2 && isSearching.city) {
      axInstTD
        .post('https://api.novaposhta.ua/v2.0/json/', {
          modelName: 'AddressGeneral',
          calledMethod: 'searchSettlements',
          methodProperties: {
            CityName: query.city,
            Limit: 20,
          },
        })
        .then(res => {
          const cities = res?.data?.data?.[0]?.Addresses || [];
          setQueries(prev => ({...prev, city: cities}));
        })
        .finally(() => setIsSearching(prev => ({...prev, city: false})));
    }

    if (
      selectedQuery.City.MainDescription &&
      !isSearching.warehouse &&
      query.warehouse.length < 2
    ) {
      axInstTD
        .post('https://api.novaposhta.ua/v2.0/json/', {
          modelName: 'AddressGeneral',
          calledMethod: 'getWarehouses',
          methodProperties: {
            Language: 'UA',
            CityName: selectedQuery.City.MainDescription,
          },
        })
        .then(res => {
          setQueries(prev => ({
            ...prev,
            warehouse: res?.data?.data || [],
          }));
        });
    }

    if (query.warehouse.length > 2 && isSearching.warehouse) {
      axInstTD
        .post('https://api.novaposhta.ua/v2.0/json/', {
          modelName: 'AddressGeneral',
          calledMethod: 'getWarehouses',
          methodProperties: {
            Language: 'UA',
            CityName: selectedQuery.City.MainDescription,
            FindByString: query.warehouse,
          },
        })
        .then(res => {
          setQueries(prev => ({
            ...prev,
            warehouse: res?.data?.data || [],
          }));
        })
        .finally(() => setIsSearching(prev => ({...prev, warehouse: false})));
    }
  }, [
    query.city,
    query.warehouse,
    isSearching.city,
    isSearching.warehouse,
    selectedQuery.City.MainDescription,
  ]);

  const handleQuerySelect = (type, data) => {
    if (type === 'city') {
      setSelectedQuery(prev => ({
        ...prev,
        City: {
          Present: data.Present,
          DeliveryCity: data.DeliveryCity,
          MainDescription: data.MainDescription,
          Ref: data.Ref,
        },
      }));
      setQuery({city: data.MainDescription, warehouse: ''});
      setQueries(prev => ({...prev, city: []}));
    }

    if (type === 'warehouse') {
      setSelectedQuery(prev => ({
        ...prev,
        Warehouse: {
          Ref: data.Ref,
          Description: data.Description,
          WarehouseStatus: data.WarehouseStatus,
        },
      }));
      setQuery(prev => ({...prev, warehouse: data.Description}));
      setQueries(prev => ({...prev, warehouse: []}));
    }
  };

  const handleSaveWarehouse = async () => {
    try {
      await updateSenderCityNpWarehouse(
        userSelectedData?.customer_id,
        frontendData.user.id,
        selectedQuery.City.MainDescription,
        selectedQuery.Warehouse.Description,
      );

      setIsDisabled(true);
      setTimeout(() => {
        getUserCityNpWarehouse(
          userSelectedData.customer_id,
          frontendData.user.id,
        );
      }, 4000);
    } catch (error) {
      console.error('Ошибка при сохранении отделения:', error);
    }
  };

  useEffect(() => {
    if (userCityNpWarehouse?.loading) {
      setIsDisabled(true);
    } else {
      setIsDisabled(false);
    }

    if (
      userCityNpWarehouse?.data &&
      userCityNpWarehouse?.data?.user_city &&
      userCityNpWarehouse?.data?.user_np_warehouse
    ) {
      setIsEditingWarehouse(false);
      setAdress(
        `${userCityNpWarehouse?.data?.user_city}, ${userCityNpWarehouse?.data?.user_np_warehouse}`,
      );
    }
  }, [userCityNpWarehouse]);

  const editIcon = onClick => (
    <Button
      type="icon"
      onClick={onClick}
      style={{
        padding: 0,
        marginLeft: 8,
        minWidth: 'auto',
        maxWidth: 'min-content',
      }}>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
          d="M8 13.3335H14"
          stroke="#C8CAD8"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11 2.33316C11.2652 2.06794 11.6249 1.91895 12 1.91895C12.1857 1.91895 12.3696 1.95553 12.5412 2.0266C12.7128 2.09767 12.8687 2.20184 13 2.33316C13.1313 2.46448 13.2355 2.62038 13.3066 2.79196C13.3776 2.96354 13.4142 3.14744 13.4142 3.33316C13.4142 3.51888 13.3776 3.70277 13.3066 3.87435C13.2355 4.04593 13.1313 4.20184 13 4.33316L4.66667 12.6665L2 13.3332L2.66667 10.6665L11 2.33316Z"
          stroke="#C8CAD8"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </Button>
  );

  return (
    <main className="dashboard">
      <DashboardBanner />
      <div className={classes.container}>
        <div className={classes.back}>
          <DashboardButtonBack />
        </div>
        <div className={classes.body}>
          <h5 style={{marginBottom: 25}}>
            Налаштування адреси відправника для формування ттн
          </h5>

          {!personalManager ? (
            <p>Недоступно</p>
          ) : (
            <>
              <p
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 6,
                  color: 'black',
                  fontSize: 14,
                  FontWeight: 400,
                }}>
                Поточна адреса відправника:{' '}
                <i style={{fontSize: 12}}>
                  {adress?.length > 0 ? adress : 'Адреса відсутня'}
                </i>
                {!userCityNpWarehouse?.loading &&
                  editIcon(() => {
                    setIsEditingWarehouse(true);
                    setQuery({city: '', warehouse: ''});
                    setQueries({city: [], warehouse: []});
                    setSelectedQuery({
                      City: {
                        Present: '',
                        DeliveryCity: '',
                        MainDescription: '',
                        Ref: '',
                      },
                      Warehouse: {
                        Ref: '',
                        Description: '',
                        WarehouseStatus: '',
                      },
                    });
                    setIsSearching({city: true, warehouse: false});
                  })}
              </p>

              {isEditingWarehouse && (
                <div className={classes.novaPoshtaSelect}>
                  <TextField
                    label="Місто"
                    value={query.city}
                    onChange={e => {
                      setQuery({city: e.target.value, warehouse: ''});
                      setIsSearching(prev => ({...prev, city: true}));
                    }}
                    fullWidth
                  />

                  {queries.city.length > 0 && (
                    <List className={classes.dropdown}>
                      {queries.city.map(city => (
                        <ListItem
                          button
                          key={city.Ref}
                          onClick={() => handleQuerySelect('city', city)}>
                          <ListItemText primary={city.MainDescription} />
                        </ListItem>
                      ))}
                    </List>
                  )}

                  {selectedQuery.City.MainDescription && (
                    <div style={{position: 'relative'}}>
                      <TextField
                        label="Відділення"
                        value={query.warehouse}
                        onChange={e => {
                          const value = e.target.value;

                          setQuery(prev => ({
                            ...prev,
                            warehouse: value,
                          }));

                          setIsSearching(prev => ({
                            ...prev,
                            warehouse: true,
                          }));
                        }}
                        fullWidth
                        style={{marginTop: 8}}
                      />

                      {queries.warehouse.length > 0 && (
                        <List className={classes.dropdown}>
                          {queries.warehouse.map(wh => (
                            <ListItem
                              button
                              key={wh.Ref}
                              onClick={() =>
                                handleQuerySelect('warehouse', wh)
                              }>
                              <ListItemText primary={wh.Description} />
                            </ListItem>
                          ))}
                        </List>
                      )}
                    </div>
                  )}

                  {selectedQuery.Warehouse.Description && (
                    <Button
                      variant="contained"
                      disabled={isDisabled}
                      onClick={handleSaveWarehouse}
                      className={classes.saveButton}
                      style={{marginTop: 12}}>
                      Зберегти
                    </Button>
                  )}
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </main>
  );
};

function mapState(state) {
  const {
    frontendData,
    personalManager,
    userSelectedData,
    userCityNpWarehouse,
    senderCityNpWarehouse,
  } = state;

  return {
    frontendData,
    personalManager,
    userSelectedData,
    userCityNpWarehouse,
    senderCityNpWarehouse,
  };
}

const actionCreators = {
  getUserCityNpWarehouse: userActions.getUserCityNpWarehouse,
  getPersonalManager: userActions.getPersonalManager,
  updateSenderCityNpWarehouse: userActions.updateSenderCityNpWarehouse,
};

export default connect(mapState, actionCreators)(DashboardStorekeeperSettings);
